// extracted by mini-css-extract-plugin
export default {"content":"privacy_policy_content__TeWsw","top_container":"privacy_policy_top_container__NiLRI"};